import React, { useContext, useMemo } from 'react';

export type GutterConfig = {
  reorderingEnabled?: boolean;
  listCollapsingEnabled?: boolean;
};

const GutterConfigContext = React.createContext<GutterConfig>({});

interface GutterConfigProviderProps {
  children: React.ReactNode;
  config: GutterConfig;
}

export const useGutterConfig = () => useContext(GutterConfigContext);

const GutterConfigProvider = ({
  children,
  config,
}: GutterConfigProviderProps) => {
  const value: GutterConfig = useMemo(
    () => ({
      reorderingEnabled: config.reorderingEnabled,
      listCollapsingEnabled: config.listCollapsingEnabled,
    }),
    [config.reorderingEnabled, config.listCollapsingEnabled],
  );
  return (
    <GutterConfigContext.Provider value={value}>
      {children}
    </GutterConfigContext.Provider>
  );
};

export default GutterConfigProvider;
